/**
 * Reviews & Approvals — Phase 59 unified inbox.
 *
 * Per the user's directive: ONE list, no nested views. All approval kinds
 * (leave / purchase / reimbursement / weekly report / review / new employee /
 * new client / new vendor / recruitment / grievance) flow through the same
 * Approvals component with tag-based filtering. The legacy "Reviews tracker"
 * panel was removed — review sign-offs surface here too via `kind=review`.
 */
import React from "react";
import Approvals from "@/pages/Approvals";

export default function ReviewsAndApprovals() {
  return <Approvals />;
}
